const oudirectBase = "/oudirect/";
const inspectionsBase = `${oudirectBase}inspections/`;

const Pages = {
  Home: oudirectBase,
  HomeDefault: `${oudirectBase}Default`,
  KosherCertificates: `${oudirectBase}KosherCertificates`,
  ScheduleB: `${oudirectBase}ScheduleB`,
  ScheduleA: `${oudirectBase}ScheduleA`,
  Financials: `${oudirectBase}Financials`,
  Contacts: `${oudirectBase}Contacts`,
  Trademarks: `${oudirectBase}Trademarks`,
  SubmissionsOverview: `${oudirectBase}SubmissionsOverview`,
  RfrAssignments: `${oudirectBase}RfrAssignments`,
  CopackerFacilities: `${oudirectBase}CopackerFacilities`,
  UkdCompanies: `${oudirectBase}UkdCompanyList`,
  UkdProducts: `${oudirectBase}UkdProductList`,
  UserLogin: `${oudirectBase}UserLogin`,
  Washer: `${oudirectBase}Washer`,
  WorkflowOverview: `${oudirectBase}WorkflowOverview`,
  WorkflowDetailIngredients: `${oudirectBase}WorkflowDetailIngredients`,
  WorkflowDetailProducts: `${oudirectBase}WorkflowDetail`,
  FormsAndApplications: `${oudirectBase}FormsAndApplications`,
  IarSubmissions: `${oudirectBase}IarSubmissions`,
  RcRfrContacts: `${oudirectBase}RcRfrContacts`,
  CompanyRcList: `${oudirectBase}CompanyRcList`,
  MiniCrm: `${oudirectBase}MiniCrm`,
  ChometzRcCompanies: `${oudirectBase}ChometzRcCompanies`,
  ChometzSales: `${oudirectBase}ChometzSales`,
  InspectionsSubmenu: `${oudirectBase}DefaultInspections`,
  RfrVisitsSearch: `${inspectionsBase}RfrVisitsSearch`,
  VisitInspectionForm: `${inspectionsBase}RfrVisitInspectionForm`,
  TripLogDetails: `${inspectionsBase}TripLogDetails`,
  RfrTripLog: `${inspectionsBase}RfrTripLog`,
  EfrTripExpenses: `${inspectionsBase}EfrTripExpenses`,
  VisitsOverview: `${inspectionsBase}VisitsOverview`,
  PlantHistory: `${oudirectBase}PlantHistory/:plantId`,
  PlantVisitDetails: `${oudirectBase}PlantVisitDetails/:visitId`,
  TravelMap: `${oudirectBase}TravelMap`,
  Login: "/login",
  HostedLogin: "/login/hosted",
  LoginCallback: "/login/callback",
  ResetPassword: "/reset-password",
} as const;

export { Pages };